export  default [
  {"name":"zhubaoshipin","tag":"珠宝饰品"},
  {"name":"jujia","tag":"居家"},
  {"name":"daifahuo","tag":"待发货"},
  {"name":"paixing","tag":"排行"},
  {"name":"yiliao","tag":"医疗"},
  {"name":"tianmaofenqi","tag":"天猫分期"},
  {"name":"shengritequan","tag":"生日特权"},
  {"name":"kefuyouxian1","tag":"客服优先"},
  {"name":"app1","tag":"app"},
  {"name":"browser","tag":"browser"},
  {"name":"copy","tag":"copy"},
  {"name":"file1","tag":"file"},
  {"name":"rest","tag":"rest"},
  {"name":"upload1","tag":"upload"},
  {"name":"attention","tag":"Attention"},
  {"name":"quanbudingdan","tag":"全部订单"},
  {"name":"adjust","tag":"adjust"},
  {"name":"mobile","tag":"mobile"},
  {"name":"unie642","tag":"健康茶饮"},
  {"name":"computer1","tag":"computer"},
  {"name":"wodejiankangziliao","tag":"我的健康资料"},
  {"name":"yingyongguanli1","tag":"应用管理"},
  {"name":"qiapianxingshi","tag":"卡片形式"},
  {"name":"weibiaoti13","tag":"模型管理"},
  {"name":"jiankangguanli","tag":"健康管理"},
  {"name":"xiaoshoudanguanli","tag":"29-销售单管理"},
  {"name":"wodedingdan","tag":"我的订单"},
  {"name":"yijianfankui","tag":"意见反馈"},
  {"name":"duoyuyan","tag":"多语言"},
  {"name":"fuzhi2","tag":"复制"},
  {"name":"shouji","tag":"手机"},
  {"name":"tupian","tag":"图片"},
  {"name":"jianyuede","tag":"简约的"},
  {"name":"wenzhangguanli","tag":"文章管理02"},
  {"name":"suyaniconchanpinleibufenzuodaohangbufen87","tag":"部门管理"},
  {"name":"zixunguanlizixunfuwuguanli","tag":"咨询管理 咨询服务 管理"},
  {"name":"lanmupeizhi","tag":"栏目配置"},
  {"name":"lanmupeizhi1","tag":"栏目配置"},
  {"name":"dingdanguanli","tag":"订单管理"},
  {"name":"caiwuguanli","tag":"财务管理"},
  {"name":"dingdanguanli1","tag":"订单管理"},
  {"name":"dingdanguanli2","tag":"订单管理"},
  {"name":"dingdanguanli4","tag":"订单管理"},
  {"name":"xiangbaoleimu","tag":"箱包类目"},
  {"name":"yiliao1","tag":"医疗"},
  {"name":"tousuguanli","tag":"投诉管理"},
  {"name":"wangluo","tag":"网络"},
  {"name":"yunyingguanli","tag":"运营管理"},
  {"name":"jiankong","tag":"监控"},
  {"name":"dashuju","tag":"大数据"},
  {"name":"dingdanguanli5","tag":"订单管理"},
  {"name":"xitongzhuangtai","tag":"系统状态"},
  {"name":"xiaofeimingxidan","tag":"消费明细单"},
  {"name":"wuliaoguanli","tag":"物料管理"},
  {"name":"fapiaoguanli","tag":"发票管理"},
  {"name":"yuyueguanli","tag":"预约管理"},
  {"name":"xiangmuguanli","tag":"项目管理"},
  {"name":"paibanguanli","tag":"排班管理"},
  {"name":"-peizhishujuyuan","tag":"14-配置数据源"},
  {"name":"bumenguanli","tag":"部门管理"},
  {"name":"xianweijing","tag":"显微镜"},
  {"name":"yiliaoanquan","tag":"医疗安全"},
  {"name":"yiliaowenjian","tag":"医疗文件"},
  {"name":"yixueziliao","tag":"医学资料"},
  {"name":"peizhi","tag":"配置"},
  {"name":"guanlizhuanjiawenzhang","tag":"管理专家文章"},
  {"name":"yizhanshipeizhi","tag":"一站式配置"},
  {"name":"shujuguanli","tag":"数据管理"},
  {"name":"liebiao1","tag":"列表"},
  {"name":"dingdanjihe","tag":" 订单集合"},
  {"name":"jingdianwanfa","tag":"经典玩法"},
  {"name":"web-icon-","tag":"打印"},
  {"name":"wushuju","tag":"无数据"},
  {"name":"guanli","tag":"管理"},
  {"name":"tieziguanli","tag":"帖子管理"},
  {"name":"dingyue","tag":"订阅"},
  {"name":"pingjia","tag":"评价"},
  {"name":"qiandao","tag":"签到"},
  {"name":"dingdan","tag":"订单"},
  {"name":"kaoqinguanli","tag":"考勤管理"},
  {"name":"rizhiguanli","tag":"日志管理"},
  {"name":"sijiguanli","tag":"司机管理"},
  {"name":"web-icon-1","tag":"制作工序配置"},
  {"name":"xiaozhan","tag":"小栈"},
  {"name":"navicon-dsrwpz","tag":"定时任务配置"},
  {"name":"navicon-yqgl","tag":"园区管理"},
  {"name":"navicon-qggl","tag":"请购管理"},
  {"name":"navicon-gggl","tag":"公告管理"},
  {"name":"navicon-dxgnpz","tag":"短信功能配置"},
  {"name":"navicon-lcpz","tag":"流程配置"},
  {"name":"tiaoshi","tag":"调试"},
  {"name":"changjingguanli","tag":"场景管理"},
  {"name":"guanlianshebei","tag":"关联设备"},
  {"name":"ceshishenqing","tag":"测试申请"},
  {"name":"renjijiaohu","tag":"人机交互"},
  {"name":"shiyongwendang","tag":"使用文档"},
  {"name":"tianshenpi","tag":"提案审批"},
  {"name":"shujukanban","tag":"数据看板"},
  {"name":"yingyongguanli","tag":"应用管理"},
  {"name":"xitongguanli","tag":"系统管理"},
  {"name":"navicon-jkpg","tag":"健康评估"},
  {"name":"baobiaoguanli","tag":"报表管理"},
  {"name":"yingyongguanli3","tag":"应用管理"},
  {"name":"xitongpeizhi","tag":"系统配置"},
  {"name":"biaodanguanli","tag":"表单管理"},
  {"name":"dingdanguanli6","tag":"订单管理"},
  {"name":"jifenguanli","tag":"积分管理"},
  {"name":"tuwenguanli","tag":"图文管理"},
  {"name":"icon_renwujincheng","tag":"icon_任务进程"},
  {"name":"icon_shiyongwendang","tag":"icon_使用文档"},
  {"name":"tubiao-bingtu","tag":"图表-饼图"},
  {"name":"tubiao-zhexiantu","tag":"图表-折线图"},
  {"name":"tubiao-zhuzhuangtu","tag":"图表-柱状图"},
  {"name":"zuzhiqunzu","tag":"组织群组"},
  {"name":"rizhiguanli1","tag":"日志管理"},
  {"name":"shebeiguanli","tag":"设备管理"},
  {"name":"deploymentunit","tag":"deployment unit"},
  {"name":"dingdanguanli7","tag":"订单管理"},
  {"name":"yunduanshangchuan","tag":"云端上传"},
  {"name":"desktop","tag":"desktop"},
  {"name":"yingyongAPP_o","tag":"应用APP_o"},
  {"name":"baoguo_dabao_o","tag":"包裹_打包_o"},
  {"name":"CPhezuo_o","tag":"CP合作_o"},
  {"name":"xinwen_o","tag":"新闻_o"},
  {"name":"jubao","tag":"32*32 举报"},
  {"name":"guanliyuan","tag":"管理员"},
  {"name":"bianpingguanli","tag":"扁平管理"},
  {"name":"yiliaoweisheng-","tag":"医疗卫生-21"},
  {"name":"yiliaoweisheng-1","tag":"医疗卫生-35"},
  {"name":"yiliaoweisheng-2","tag":"医疗卫生-69"},
  {"name":"yiliaoweisheng-3","tag":"医疗卫生-78"},
  {"name":"yiliaoweisheng-4","tag":"医疗卫生-82"},
  {"name":"yiliaoweisheng-5","tag":"医疗卫生-97"},
  {"name":"yiliaoweisheng-6","tag":"医疗卫生-98"},
  {"name":"yiliaoweisheng-7","tag":"医疗卫生-207"},
  {"name":"yiliaoweisheng-8","tag":"医疗卫生-231"},
  {"name":"yiliaoweisheng-9","tag":"医疗卫生-232"},
  {"name":"guanli1","tag":"管理2"},
  {"name":"zhihangfankui","tag":"执行反馈"},
  {"name":"gongdanqueren","tag":"工单确认"},
  {"name":"gongdan","tag":"工单"},
  {"name":"xiaoxi","tag":"消息"},
  {"name":"chaxun","tag":"查询"},
  {"name":"daibanshixiang","tag":"待办事项"},
  {"name":"fuzhi","tag":"复制"},
  {"name":"cangkuguanli","tag":"仓库管理"},
  {"name":"chukuguanli","tag":"出库管理"},
  {"name":"zixunguanli","tag":"资讯管理"},
  {"name":"zichanguanli","tag":"资产管理"},
  {"name":"tianjiatupian1","tag":"添加图片"},
  {"name":"peizhi-","tag":"配置"},
  {"name":"cangkuguanli-","tag":"仓库管理"},
  {"name":"rukuguanli-","tag":"入库管理"},
  {"name":"activity","tag":"activity"},
  {"name":"createtask","tag":"createtask"},
  {"name":"group","tag":"group"},
  {"name":"manage","tag":"manage"},
  {"name":"mobilephone","tag":"mobilephone"},
  {"name":"send","tag":"send"},
  {"name":"workbench","tag":"workbench"},
  {"name":"eduguanli","tag":"额度管理"},
  {"name":"jiaoyixulie","tag":"菜单管理"},
  {"name":"tupian1","tag":"图片管理"},
  {"name":"bumenguanli1","tag":"部门管理"},
  {"name":"gonggao","tag":"公告管理"},
  {"name":"shouhui","tag":"收购资格管理"},
  {"name":"xitongguanli1","tag":"系统管理"},
  {"name":"shebeiguanli1","tag":"设备管理"},
  {"name":"dingdanguanli8","tag":"订单管理"},
  {"name":"mobanguanli","tag":"模板管理"},
  {"name":"yonghupeizhi","tag":"配置"},
  {"name":"icon_calendar","tag":"icon_calendar"},
  {"name":"icon_dispose","tag":"icon_dispose"},
  {"name":"icon_doc","tag":"icon_doc"},
  {"name":"icon_subordinate","tag":"icon_subordinate"},
  {"name":"icon_statistics","tag":"icon_statistics"},
  {"name":"cz-jktj","tag":"操作-健康体检"},
  {"name":"wenzhangguanli1","tag":"文章管理"},
  {"name":"cepingguanli","tag":"测评管理"},
  {"name":"xitongpeizhi1","tag":"系统配置"},
  {"name":"zuzhiguanli","tag":"组织管理"},
  {"name":"xitongguanli-jianchayiju","tag":"系统管理-检查依据"},
  {"name":"settings-line","tag":"settings-line"},
]
